exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/next-step/next-step.component.scss
// module id = ../../../../../src/app/next-step/next-step.component.scss
// module chunks = main